/**
 * FAQ Anchor Navigation
 * Handles scrolling to and opening FAQ items when accessed via anchor links
 */
(function() {
  'use strict';
  
  function initFAQAnchorNavigation() {
    function scrollToFAQItem() {
      if (!window.location.hash) return;
      
      var searchText = decodeURIComponent(window.location.hash.substring(1));
      var details = document.querySelectorAll('[data-faq-question]');
      
      for (var i = 0; i < details.length; i++) {
        var questionText = details[i].getAttribute('data-faq-question');
        
        if (questionText === searchText) {
          var targetDetails = details[i];
          var summary = targetDetails.querySelector('.faq__summary');
          
          // Open the FAQ if it's closed
          if (summary && !targetDetails.hasAttribute('open')) {
            summary.click();
          }
          
          // Scroll after animation
          setTimeout(function() {
            var headerOffset = 100;
            var elementPosition = targetDetails.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Highlight effect
            targetDetails.style.transition = 'background-color 0.3s ease';
            targetDetails.style.backgroundColor = '#f0f0f0';
            setTimeout(function() {
              targetDetails.style.backgroundColor = '';
            }, 2000);
          }, 150);
          
          break;
        }
      }
    }
    
    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(scrollToFAQItem, 100);
      });
    } else {
      setTimeout(scrollToFAQItem, 100);
    }
    
    // Run on hash change
    window.addEventListener('hashchange', function() {
      setTimeout(scrollToFAQItem, 50);
    });
  }
  
  initFAQAnchorNavigation();
})();